import { 
    branch_branch_create,
    branch_list_get,
    branch_branch_update,
    branch_branch_remove
} from '../../Models/Management/Branch_Model';

//======== BRANCH ========
//====== GET ALL BRANCH =====
export const onGetBranch = async function (data) {
    let userid      = data.userid   || "";
    let useraccess  = ["allen", "roger"]; 
    return new Promise((resolve, reject) => {
        branch_list_get({}).
        then((response) => response.json()).
        then(val => {
            //===== IF ONLY USER ACCESS IS ALLEN THEN CAN ONLY SEE THOSE WFH ====
            if(useraccess.filter(x => x == userid).length > 0){
                // ONLY FILTER WITH WFH
                val.data    = val.data.filter(item => {
                    let access = ["Nax Digital", "JB", "Jasmine House", "Cambodia"];
                    if(access.filter(x => x == item.name).length > 0){
                        return item.name;
                    }
                })
            }

            resolve({ status: 'ok', msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}

//======== CREATE ======
export const onCreateBranch = (data) => {
    return new Promise((resolve, reject) => {
        branch_branch_create(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    });
}

//======== EDIT ========
export const onEditBranch = (data) => {
    return new Promise((resolve, reject) => {
        branch_branch_update(data).
        then((response) => response.json()).
        then(val => {
            resolve({ status: 'ok', msg: val.msg, data: val.data })
        }).
        catch((error) => {
            console.log("error: ", error);
            reject({ status: error, msg: "An unexpected error occurred. Contact your system administrator " });
        });
    })
}

